module.exports = __webpack_public_path__ + "img/background-truckrally.c60bf6c2.png";